/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserResDto } from '../../models/user-res-dto';

export interface UserControllerMe$Params {}

export function userControllerMe(
  http: HttpClient,
  rootUrl: string,
  params?: UserControllerMe$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<UserResDto>> {
  const rb = new RequestBuilder(rootUrl, userControllerMe.PATH, 'get');
  if (params) {
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserResDto>;
      }),
    );
}

userControllerMe.PATH = '/user/me';
